import { IsNumber, IsObject, IsString } from 'class-validator';
import { WebPaymentTypeEnum } from '@up/data';

export interface EvervaultData {
  isValid?: boolean;
  bin?: string;
  cvc?: string;
  expMonth?: string;
  expYear?: string;
  lastFour?: string;
  number?: string;
  type?: string;
  name?: string;
  nameOnCard?: string;
  originalIsValid?: boolean;
  encryptedCard?: any;
}

export class EvervaultPaymentRequestDto {
  @IsString()
  authorizationToken: string;

  @IsNumber()
  orderId?: number;

  @IsObject()
  evervaultData: EvervaultData;

  @IsNumber()
  paymentId?: number;

  @IsString()
  customerId?: string;

  @IsObject()
  webPaymentType?: WebPaymentTypeEnum;

  @IsString()
  currencyCode?: string;

  @IsString()
  paymentMethodId?: number;
}
